<template>
	<form class="form-horizontal" @submit.prevent="save">
		<div class="animated fadeIn">
			<b-card class="min-vh-100">
				<div class="display-table full-width mb-2">
					<strong class="card-title">{{ $route.meta.label }}</strong>
				</div>
				<b-row>
					<ResponseAlert ref="response" />
					<b-col>
						<div class="my-4">
							<b-img :src="getUrlOfFile(models.thumbnail)" fluid class="d-block m-auto"
								style="max-height: 300px" />
							<b-button class="btn-upload btn-block mt-3" @click="$refs.filemanager.show('thumbnail')">
								<i class="fa fa-upload"></i> Upload Image
							</b-button>
							<b-form-input v-if="!vars.onLoadData" hidden v-model="models.thumbnail"
								v-validate="'required'" data-vv-name="image"></b-form-input>

							<div v-if="errors.has('image')">
								<p class="text-danger mt-1 text-center">{{ errors.first('image') }}</p>
							</div>
						</div>
					</b-col>
				</b-row>
				<b-row>
					<b-col md="5">
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('title') }" label="Title">
							<b-form-input v-model="models.title" v-validate="'required'" data-vv-name="title">
							</b-form-input>
							<div v-if="errors.has('title')">
								<p class="text-danger">{{ errors.first('title') }}</p>
							</div>
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('link') }" label="Link">
							<b-form-input v-model="models.link" v-validate="'required|url'" data-vv-name="link">
							</b-form-input>
							<div v-if="errors.has('link')">
								<p class="text-danger">{{ errors.first('link') }}</p>
							</div>
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('category') }" label="Category">
							<b-form-select v-model="models.podcast_category_id" :options="masters.categories"></b-form-select>
							<div v-if="errors.has('category')">
								<p class="text-danger">{{ errors.first('category') }}</p>
							</div>
						</b-form-group>
					</b-col>
					<b-col md="7">
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('publish date') }" label="Publish Date">
							<b-form-input type="datetime-local" v-model="models.publish_date" v-validate="'required'"
								data-vv-name="publish date">
							</b-form-input>
							<div v-if="errors.has('publish date')">
								<p class="text-danger">{{ errors.first('publish date') }}</p>
							</div>
						</b-form-group>
						<b-form-group>
							<b-form-group v-bind:class="{ 'is-invalid': errors.has('description') }"
								label="Description">
								<Editor :value="models.description" @input="value => models.description = value" />
								<div v-if="errors.has('description')">
									<p class="text-danger">{{ errors.first('description') }}</p>
								</div>
							</b-form-group>
							<div class="col-sm-12 no-padding mt-3 mb-1">
								<label class="radio-inline no-padding">
									<input type="radio" v-model="models.status" value="publish">
									<span>Publish</span>
								</label>
								<label class="radio-inline">
									<input type="radio" v-model="models.status" value="draft">
									<span>Draft</span>
								</label>
							</div>
						</b-form-group>
					</b-col>
				</b-row>
				<template #footer>
					<b-button type="submit" variant="primary" class="btn-min-width rounded float-left">
						Save
					</b-button>
					<b-button type="button" variant="light" class="btn-min-width rounded float-left"
						@click="$router.push({ name: config.uri })">
						Cancel
					</b-button>
				</template>
				<Filemanager ref="filemanager" name="categories" @selectMedia="selectMedia" />

			</b-card>
		</div>
	</form>
</template>
<script>
import moment from 'moment'
import api from '@/utils/api.js'
import ResponseAlert from '@/components/response_alert';
import Filemanager from '@/components/file_manager';
import Editor from '@/components/editor';

import {
	getUrlOfFile
} from '@/utils/helpers.js';

export default {
	name: 'ListPodcast',
	components: {
		ResponseAlert,
		Filemanager,
		Editor
	},
	data() {
		return {
			config: {
				uri: this.$route.meta.permission.link,
			},
			models: {
				title: "",
				publish_date: "",
				description: "",
				thumbnail: "",
				podcast_category_id: null,
				link: "",
				status: "publish"
			},
			editorOption: {
				modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike'],
						[{ 'header': 1 }, { 'header': 2 }],
						[{ 'list': 'ordered' }, { 'list': 'bullet' }],
						['link', 'image'],
						['clean']
					],
				}
			},
			vars: {
				onLoadData: false,
			},
			masters: {
				categories: [
					{
						value: null,
						text: 'Select Category'
					}
				],
			},
			moment
		}
	},
	created() {
		let _ = this
		_.getCategories();
		_.getById();
	},
	methods: {
		getById() {
			const _ = this;
			if (_.$route.params.id) {
				_.vars.onLoadData = true
				_.$axios.get(`${api.podcast}/${_.$route.params.id}`)
					.then(res => {
						const { data } = res.data;
						_.models.title = data.title,
							_.models.description = data.description,
							_.models.thumbnail = data.thumbnail,
							_.models.link = data.link,
							_.models.podcast_category_id = data.podcast_category_id,
							_.models.publish_date = moment(data.publish_date).format('YYYY-MM-DDTHH:mm'),
							_.models.status = data.status

						this.$nextTick(() => {
							_.vars.onLoadData = false
						});
					}).catch(() => {
						_.vars.onLoadData = false
						_.$router.push({
							name: 'page404'
						})
					});
			}
		},

		getUrlOfFile(file) {
			return getUrlOfFile(file, true);
		},

		selectMedia(field, media) {
			const _ = this;
			const imageExtension = ['jpg', 'jpeg', 'png']
			const isExtensionMatch = extensions => extensions.indexOf(media.file.substring(media.file.lastIndexOf(".") + 1)) > -1

			if (field === 'image' && !isExtensionMatch(imageExtension)) {
				return alert('Only accept image file')
			}
			console.log(media)
			_.models.thumbnail = media.file;
		},

		save() {
			const _ = this;
			_.$validator.validate().then(valid => {
				if (valid) {
					let request = "";
					let message = "create"
					console.log(_.models);
					if (!_.$route.params.id) {
						request = _.$axios.post(api.podcast, _.models);
					} else {
						message = "update"
						request = _.$axios.put(`${api.podcast}/${_.$route.params.id}`, _.models);
					}
					request
						.then(() => {
							this.$showToast('Success', `Success ${message} podcast`)
							_.$router.push({
								name: _.config.uri
							})
						})
						.catch(error => _.$refs.response.setResponse(error.response.data.message, 'danger'));
				} else {
					window.scrollTo(0, 0);
				}
			});
		},

		getCategories() {
			const _ = this
			_.$axios.get(api.podcast_category, {
				params: {
					status: 'active',
					page: 1,
					per_page: 100,
					sort: 'asc',
					orderby: 'name'
				}
			}).then(res => {
				const { rows } = res.data.data
				rows.forEach(row => {
					_.masters.categories.push({
						value: row.id,
						text: row.name
					})
				})
			});
		}
	},
	computed: {},
	watch: {}
}
</script>